import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class TextDocumentSectionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="title"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Cím"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="text"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Szöveg"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TextDocumentSectionForm);
